import { render, staticRenderFns } from "./Active-Inactive-Sensors.vue?vue&type=template&id=97bb5a82&scoped=true"
import script from "./Active-Inactive-Sensors.vue?vue&type=script&lang=js"
export * from "./Active-Inactive-Sensors.vue?vue&type=script&lang=js"
import style0 from "./Active-Inactive-Sensors.vue?vue&type=style&index=0&id=97bb5a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bb5a82",
  null
  
)

export default component.exports